module.exports = __webpack_public_path__ + "media/images/proof_links/discordapp-014ecf4ef373e211de37c5bc8ab96249.svg";